export default {
    fields:[
        {
            key: "condition",
            label:"condition",
            sorter: false,
            filter: false,
            
        },
        {
            key: "value",
            label:"value",
            sorter: false,
            filter: false,
        },
        {
            key: "options",
            label:"options",
            sorter: false,
            filter: false,
            _style: 'width:10%',
            _classes: "text-center"  
        },
    ],
    items:[]
}